var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.column.displayValue && this.column.displayValue !== null
    ? _c("span", [_vm._v(_vm._s(_vm.displayValue))])
    : _vm.value && _vm.titleColumn
    ? _c("span", { staticClass: "column" }, [
        _c("span", { staticClass: "text-primary" }, [
          _vm._v(_vm._s(_vm._f("relationLabel")(_vm.value, _vm.titleColumn)))
        ]),
        _vm.subtitleColumn
          ? _c("span", { staticClass: "text-grey-7 q-caption" }, [
              _vm._v(
                _vm._s(_vm._f("relationLabel")(_vm.value, _vm.subtitleColumn))
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }